var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { HeaderBusiness } from '@business/common/header';
import { getUrlParams } from '@common/utils/url';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
var UnableSchedulePage = /** @class */ (function (_super) {
    __extends(UnableSchedulePage, _super);
    function UnableSchedulePage() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.state = {
            callCenter: '(888) 330-4969',
            isResidentScheduleOptimization: (_a = _this.props.location) === null || _a === void 0 ? void 0 : _a.pathname.includes("ResidentScheduleOptimization")
        };
        return _this;
    }
    UnableSchedulePage.prototype.componentDidMount = function () {
        var _this = this;
        var _a, _b;
        if (this.state.isResidentScheduleOptimization) {
            this.setState({ callCenter: '' });
            var token = (_b = (_a = getUrlParams()) === null || _a === void 0 ? void 0 : _a.token) === null || _b === void 0 ? void 0 : _b.split("?")[0];
            if (token) {
                this.props.getCurrentUser().then(function () {
                    var _a;
                    _this.setState({ callCenter: (_a = _this.props.currentUser) === null || _a === void 0 ? void 0 : _a.clientCallCenterNumber });
                });
            }
        }
    };
    UnableSchedulePage.prototype.render = function () {
        return (React.createElement("div", { className: "result-cont text-center w-50 center-auto", style: { paddingTop: 120 } },
            React.createElement("div", { className: "result-cricle warning" },
                React.createElement("span", { className: "iconfont icon-close" })),
            React.createElement("h3", null, "We are unable to schedule your work order at this time."),
            this.state.callCenter && React.createElement("p", { className: "text-center" },
                "Please contact us at ",
                this.state.callCenter,
                " if you have any questions.")));
    };
    UnableSchedulePage = __decorate([
        inject(HeaderBusiness),
        observer
    ], UnableSchedulePage);
    return UnableSchedulePage;
}(Component));
export { UnableSchedulePage };
;
export default UnableSchedulePage;
